import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const Bookmark = ({ bookmarks, clearBookmark }) => {
  return (
    <div className="accordion bg-none" id="bookmarks-accordion">
      <div className="card bg-none border-0">
        <div className="card-header border-0" id="bookmarks-heading">
          <h2 className="mb-0">
            <button
              tabIndex="-1"
              className="btn border-0 btn-block text-left"
              type="button"
              data-toggle="collapse"
              data-target="#bookmarks-collapse"
              aria-expanded="true"
              aria-controls="bookmarks-collapse"
            >
              Bookmarks
            </button>
          </h2>
        </div>

        <div
          id="bookmarks-collapse"
          className="collapse"
          aria-labelledby="bookmarks-heading"
          data-parent="#bookmarks-accordion"
        >
          <div className="card-body">
            <ul className="list-group">
              {bookmarks &&
                bookmarks.map((bookmark) => {
                  return (
                    <li key={bookmark.code} className="list-group-item">
                      <a href={bookmark.uri}>
                        {bookmark.name.toUpperCase()} - {bookmark.code}
                      </a>
                    </li>
                  );
                })}
              <li className="list-group-item">
                <button
                  onClick={clearBookmark}
                  className="btn btn-sm btn-secondary btn-block"
                >
                  Clear
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

Bookmark.propTypes = {
  bookmarks: PropTypes.array,
  clearBookmark: PropTypes.func,
};

export default Bookmark;
